import { render, staticRenderFns } from "./data67.vue?vue&type=template&id=e6b52d9e&scoped=true"
import script from "./data67.vue?vue&type=script&lang=js"
export * from "./data67.vue?vue&type=script&lang=js"
import style1 from "./data67.vue?vue&type=style&index=1&id=e6b52d9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b52d9e",
  null
  
)

export default component.exports